import ContactUsPage from '../../src/client/pages/contact-us';

export default ContactUsPage;
